const HISTORY_KEY = "trolet_partner_selection_history_v1";
const PENDING_KEY = "trolet_partner_selection_pending_v1";
const MAX_ENTRIES = 20;

function parseSafe(raw, fallback) {
  try {
    return JSON.parse(raw);
  } catch {
    return fallback;
  }
}

function getHistory() {
  const value = parseSafe(localStorage.getItem(HISTORY_KEY), []);
  return Array.isArray(value) ? value : [];
}

function setHistory(entries) {
  const safeEntries = Array.isArray(entries) ? entries : [];
  localStorage.setItem(HISTORY_KEY, JSON.stringify(safeEntries.slice(0, MAX_ENTRIES)));
}

function mapPayloadToEntry(payload) {
  const cart = payload?.cart || {};
  const customer = payload?.customer || {};

  return {
    id: `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
    submitted_at: payload?.submitted_at || new Date().toISOString(),
    customer_name: customer.name || "",
    customer_email: customer.email || "",
    total_price: cart.total_price || 0,
    currency: payload?.currency || "",
    items: Array.isArray(cart.items)
      ? cart.items.map((item) => ({
          product_title: item.product_title || "",
          variant_title: item.variant_title || "",
          quantity: item.quantity || 0,
          sku: item.sku || "",
        }))
      : [],
  };
}

function saveFinal(payload) {
  const history = getHistory();
  history.unshift(mapPayloadToEntry(payload));
  setHistory(history);
}

function savePending(payload) {
  const entry = mapPayloadToEntry(payload);
  sessionStorage.setItem(PENDING_KEY, JSON.stringify(entry));
}

function commitPendingIfSent() {
  const url = new URL(window.location.href);
  if (url.searchParams.get("partner_selection_sent") !== "1") return false;

  const pendingRaw = sessionStorage.getItem(PENDING_KEY);
  if (!pendingRaw) return false;

  const pending = parseSafe(pendingRaw, null);
  if (!pending) return false;

  const history = getHistory();
  history.unshift(pending);
  setHistory(history);
  sessionStorage.removeItem(PENDING_KEY);
  return true;
}

window.PartnerSelectionHistory = {
  saveFinal,
  savePending,
  commitPendingIfSent,
  list: getHistory,
};
